import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from 'context/AuthContext';
import { AppRoutes } from 'Routes/AppRoutes';
import { localizePath } from 'Utils';

type RoleRestrictedRouteType = {
	component: React.ReactNode;
	restrictedRole: string;
};

export const RoleRestrictedRoute = ({ component, restrictedRole }: RoleRestrictedRouteType) => {
	const { getAuthenticatedUserRoles } = useContext(AuthContext);

	const roles = getAuthenticatedUserRoles();

	if (!roles || roles.length === 0 || roles.every(r => r === restrictedRole)) {
		return <Navigate to={localizePath(AppRoutes.landingpage)} />;
	}

	return <>{component}</>;
};
